import { createConfirmation } from "react-confirm";
import AddMainCategoryDialog from "./AddMainCategoryDialog";

export const showAddMainCategoryDialog = createConfirmation(AddMainCategoryDialog);
